import Divider from "@/components/Divider";
import type { DividerWithLabelProps } from "./types";

/** Horizontal divider with a centered text label (e.g. "or") between two lines. */
export default function DividerWithLabel({ label = "or", subtle = false }: DividerWithLabelProps) {
  return (
    <div className="flex items-center gap-3 w-full">
      <div className="flex-1">
        <Divider subtle={subtle} />
      </div>
      <span className="text-sys-brand-on-surface-variant text-body-medium whitespace-nowrap">{label}</span>
      <div className="flex-1">
        <Divider subtle={subtle} />
      </div>
    </div>
  );
}
